import { ApiUrl } from "../utils/modules";
import { header } from "../utils/modules";

class VisiteServices {
  constructor(api) {
    this.api = api;
  }

  create(data) {
    return this.api.post(ApiUrl + "visites", data);
  }

  getStats(params = {}) {
    const query = new URLSearchParams();

    if (params.dateDebut) query.append("dateDebut", params.dateDebut);
    if (params.dateFin) query.append("dateFin", params.dateFin);

    const qs = query.toString();

    return this.api.get(ApiUrl + `visites/stats${qs ? `?${qs}` : ""}`);
  }

  getAll(params = {}) {
    const query = new URLSearchParams();

    if (params.dateDebut) query.append("dateDebut", params.dateDebut);
    if (params.dateFin) query.append("dateFin", params.dateFin);

    const qs = query.toString();

    return this.api.get(ApiUrl + `visites${qs ? `?${qs}` : ""}`, {
      ...header("json"),
    });
  }
}

export default VisiteServices;
